<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-b-modal.new-category size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Expense Category</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(addedby)="data">
                {{ data.item.addedby }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <b-button @click="edit(data.item.id,data.item.name )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-category" centered title="New Expense Category" title-class="font-18" hide-footer>
        <form @submit.prevent="addCategory">
            <div class="form-group mb-2">
            <label>Name</label>
            <input v-model="name" type="text" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-category')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="edit-category" centered title="Edit Expense Category" title-class="font-14" hide-footer>
        <form @submit.prevent="editCategory">
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Category Name</label>
            <input v-model="name" type="text" class="form-control" />
            </div>
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-category')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-category" centered title="Delete Expense Category" title-class="font-18" hide-footer>
        <form @submit.prevent="removeCategory">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Category : <b>{{ name }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-category')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { expenseCategoryMethods, expenseCategoryComputed } from "@/state/helpers";

export default {
  page: {
    title: "Expense Categories",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      title: "Expense Categories",
      items: [ {text: "Dashboard",to: "/",}, {text: "Expense Categories",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'name', label: 'Name', visible: true },
          { key: 'addedby', label: 'Added by', visible: true },
          { key: 'addedon', label: 'Added on', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      name:'',
    };
  },
  computed: {
    ...expenseCategoryComputed,
    List() { return this.expensecategories.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.expensecategories.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.expensecategories.length>0) { a=false;} else { a=true;} return a },
  },
  mounted() {
    this.fetchExpensecategories();
    this.TotalRows = this.expensecategories.length;
    this.isBusy=false;
  },
  methods: {
    ...expenseCategoryMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id,name){
      this.id=id;
      this.name=name;
      this.$bvModal.show('edit-category')
    },
    remove(id,name){
      this.id=id;
      this.name=name;
      this.$bvModal.show('delete-category')
    },
    async addCategory() { 
      let formData = new FormData();
      formData.append("name", this.name);
      let url = "/addexpensecat";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchExpensecategories();
          this.$bvModal.hide('new-category');
          this.name="";
      }
      });
    },
    async editCategory(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("name", this.name);
    let url = "/updateexpensecat";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchExpensecategories();
        this.$bvModal.hide('edit-category');
        this.name="";
      }
    });
    },
    async removeCategory() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removeexpensecat";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchExpensecategories();
        this.$bvModal.hide('delete-category');
      }
    });
    },
  },
};
</script>